import React from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';

export default function MiniFichaPLD({ entidad, setEntidad, titulo }) {
    function handleChange(campo, valor) {
        setEntidad({ ...entidad, [campo]: valor });
    }

    const esExtranjero =
        entidad.nacionalidad && entidad.nacionalidad !== 'México';
    const maxLengthRFC = esExtranjero ? 50 : 13;
    const placeholderRFC = esExtranjero ? 'ID Internacional' : 'XXXX999999XXX';

    return (
        <Card className="border-warning mt-3 shadow-sm">
            <CardHeader className="bg-warning-soft border-warning py-2">
                <h6 className="mb-0 text-uppercase font-weight-bold text-warning d-flex align-items-center">
                    <FontAwesomeIcon icon={faShieldAlt} className="mr-2" />
                    Ficha PLD: {titulo}
                </h6>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label className="small text-uppercase text-muted mb-1">
                                Nacionalidad *
                            </Label>
                            <Input
                                type="select"
                                value={entidad.nacionalidad || ''}
                                onChange={(e) =>
                                    handleChange('nacionalidad', e.target.value)
                                }
                            >
                                <option value="México">México</option>
                                <option value="Extranjero">Extranjero</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label className="small text-uppercase text-muted mb-1">
                                Nombre(s) *
                            </Label>
                            <Input
                                type="text"
                                value={entidad.nombre || ''}
                                onChange={(e) =>
                                    handleChange('nombre', e.target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label className="small text-uppercase text-muted mb-1">
                                Ap. paterno *
                            </Label>
                            <Input
                                type="text"
                                value={entidad.paterno || ''}
                                onChange={(e) =>
                                    handleChange('paterno', e.target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label className="small text-uppercase text-muted mb-1">
                                Ap. materno
                            </Label>
                            <Input
                                type="text"
                                value={entidad.materno || ''}
                                onChange={(e) =>
                                    handleChange('materno', e.target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label className="small text-uppercase text-muted mb-1">
                                RFC *
                            </Label>
                            <Input
                                type="text"
                                value={entidad.rfc || ''}
                                onChange={(e) =>
                                    handleChange(
                                        'rfc',
                                        e.target.value.toUpperCase()
                                    )
                                }
                                maxLength={maxLengthRFC}
                                placeholder={placeholderRFC}
                                className="text-uppercase"
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}
